import React from 'react'
import { URL_UPDATET_SILICITUD } from '../../router/Url';

export const UpdateSoli = ({id_code, status, notes, planta}) => {
    console.log({id_code, status, notes, planta})
    new Promise(async (resolve, reject) => {
          let query = await fetch(URL_UPDATET_SILICITUD,{
            method: 'PUT',
            headers: {
              'authorization': "marcuxo",
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id_code:id_code,
              status:status,
              notes:notes,
              planta:planta
            })
          })
          let responsito = await query.json();
          console.log(responsito);
          if(responsito){
            resolve(responsito)
          }else{
            resolve(responsito)
          }
        })
}
